import { dataCompass } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCompass = /*#__PURE__*/createIcon(dataCompass)
export default IconCompass
